module.exports = __webpack_public_path__ + "img/matchc_logo.47ce182f.png";